/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderRoutes {
  ROUTE_ACCREDITATION_UPDATE_SIDEBAR_MENU = '/atualizacao-credenciamento/:nrSeqAccreditation/tipo-credenciamento/:nrSeqTypeAccreditation',
  ROUTE_CONTRACT_DETAILS = '/contratos/:nrSeqContract/detalhes',
  ROUTE_NEGOTIATION_CONTRACTUAL_AMENDMENT = '/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/aditamento',
  ROUTE_NEGOTIATION_DRAFT = '/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/minuta-contratual',
  ROUTE_NEGOTIATION_SIDEBAR_MENU = '/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/negociacao-valores',
  ROUTE_ROUTES = '/',
  ROUTE_TECHNICAL_VISIT_APPOINTMENTS = '/visita-tecnica/:nrSeqVisit/agendamentos',
  ROUTE_TECHNICAL_VISIT_FORMS = '/visita-tecnica/:nrSeqVisit/formularios/:nrSeqForm',
  ROUTE_TECHNICAL_VISIT_INCONSISTENCIES = '/visita-tecnica/:nrSeqVisit/inconsistencias',
}
export { ProviderRoutes };
